import { API } from 'aws-amplify';
const flowtraceAPI = 'slackintegration';
const usageAPIURL = '/extension/usage';
const initAPI = { headers: {}, timeout:60000 };

const tz = {range_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone};

async function usage(qf, user) {
    try {
        const response = await API.get(flowtraceAPI, usageAPIURL, {...initAPI, queryStringParameters: { ...qf, ...tz }});

        return response;
    }
    catch (e) {
        console.error(e.message, e);
        return {exception:e, histogram:[], };
    }
}


const functions = { usage };
export default functions;
